﻿var core = require('./core.js');

$(document).ready(function () {
    $('#gototop').click(function () {
        $('body,html').animate({
            scrollTop: 0
        }, 400);
        return false;
    });

    getInform();

})

function getInform() {
    let resp = core.urlToObj(false);
    let sentObj = {};
    sentObj.orgId = resp.id;
    core.sentAjaxTo('GetChildrenBasicInfo', sentObj);
}

//основная информация 
export function setBasicInform(resp) {
    document.getElementById("ItemPreview").src = (resp.photo ? "data:image/png;base64," + resp.photo : "./images/logo_3.jpg");
    $.each(resp, (key, val) => {
        if (key === "dopinfo" || key === "osoben") {
            var queryStart = val.indexOf("http"),
                queryEnd = val.length + 1,
                query = val.slice(queryStart, queryEnd - 1),
                link = '<a href=' + query + ' target="_blank">Посмотреть<a/>';
            var str = val.slice(0, queryStart);
            val = (query.length>1 ? str+" "+link : str);
        }
        $('.base_information').find('#' + key).html(val);
    })
}



//////////////////
// WEBPACK FOOTER
// ./js/info.js
// module id = 2
// module chunks = 0 1 2